module.exports = __webpack_public_path__ + "img/thumb-ryan-g-on.69f1b402.jpg";